<template>
  
    <div ref="caroussel-container"  class="caroussel-container">
        
        <div v-if="empty" class="no-media">{{$t('language.no_media_present')}}</div>
      
        <div :class="{'hide':!mediaLength}" ref="caroussel-placeholder" class="placeholder">
        <div ref="image-viewport" class="image-viewport">
          <div class="caroussel-images" :style="computedPosition" :class="{'animate':animate}">
           
            <caroussel-image :position="index" v-for="(media, index) in computeMediaList" :key="index" :media="media"/>
          </div>
          <div class="counting-container">
            <ui-chip class="counting" color="#FFFFFF" backgroundColor="rgba(0,0,0,.5)" icon="">{{position+1}}/{{mediaLength}}</ui-chip>
          </div>

          <div class="tools-left">
            <ui-icon :loading="downloadingImage" :class='{"show-dl-button": computeShowDownloadButton}' color="#FFFFFF" backgroundColor="rgba(0,0,0,.5)" class="icon-tool dl-button" icon="file-download" @click.native="downloadMedia"/>
          </div>

          <div class="tools-right">
            <ui-icon color="#FFFFFF" backgroundColor="rgba(0,0,0,.5)" class="icon-tool" icon="expand" @click.native="toggleFullScreen"/>
          </div>

        </div>
        </div>
        
        <caroussel-gallery @input="(index)=>{clickedSmallGalleryThumbnail(index)}" :medias="medias"/>
        
    </div>
</template>

<script>
import CarousselImage from '../caroussel/CarousselImage.vue';
import CarousselGallery from '../caroussel/CarousselGallery.vue';
import { eventBus } from '../../services/EventBus.js';
import UiIcon from '../../components/UiIcon.vue';
import anime from 'animejs/lib/anime.es.js';
//import { imagePicker } from '../../services/ImagePicker.js';
import UiChip from '../../components/UiChip.vue';

import { fileSave } from '../../services/FileSave.js';


//import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

export default {
  name: 'caroussel',
  props:{
    medias:{type:Array,default:()=>{[]}}
  },
  data(){
    return {
      empty:false,
      element:undefined,
      placeHolder:undefined,
      imageViewport:undefined,
      start:{x:0,y:0},
      delta:{x:0,y:0},
      p:{x:0,y:0},
      position:0,
      zoomScale:1.0,
      zoomBase:1.0,
      zooming:false,
      animate:false,
      fullScreen:false,
      lockScroll:{x:false,y:false},
      downloadingImage:false,

    }
  },
  components: {
    CarousselImage,
    CarousselGallery,
    UiIcon,
    UiChip,
  },
  computed:{
    computeMediaList(){
      var output;
      try{
           // copy list
           output=this.medias.map(
            (item)=>{
            //var mimetype=item.url.split(".").slice(-1).pop();
            switch(item.type){
              case "jpg":
              break;
              case "png":
              break;
              case "pdf":
                item.thumbnail=require('../../assets/pdf_bg.png');
              break;
              case "mp3":
                item.thumbnail=require('../../assets/audio_bg.png');
              break;
            }
             // check extension..
             
             return item
            });
         }catch(e){
           output=[];
         }
        return output;
    },
    computeShowDownloadButton(){

      // cannot download image on desktop
      //if(!cordovaInit.isMobile()){
      //  return false;
     // }

      var hasMedias=this.medias ? this.medias.length : false
      if(hasMedias){
        if(this.medias[this.position].type=="youtube"){
          return false;
        }
        if(this.medias[this.position].type=="mp3"){
          return false;
        }
        return true;
      }


      return false
    },
    computedPosition:function(){
      var p=((this.p.x*.25)-(this.position*100));
      return {transform:"translateX("+p+"%)" }
    },
    mediaLength:function(){
      return this.medias ? this.medias.length: 0;
    },
  },
  methods:{
   _base64ToArrayBuffer(base64) { // to binary data
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    thumbLoadError(e){
      e.target.src=require('../../assets/thumb_404.png');
    },
   
    downloadMedia(){
     
      // caroussel only contains images (no pdf or such)
      if(this.downloadingImage){
        return;
      }

      // TODO: add type also for photoalbum media..
      // or better have the type come from the backend..
      var item=this.medias[this.position];
      //var type=item.type;
      var url=item.url;
      
      
      this.downloadingImage=true;
      // get base64 data from api that fetches it from other domain.
      this.$store.dispatch('get_crossdomain_photo',{img_url:url}).then(result=>{
        var base64data=result.data.img;
        var fileName=url.split("/").pop();
        // for mobile and browser
        fileSave.saveBase64ToFile(base64data, fileName);
        this.downloadingImage=false;
      })

    },

    
    ts(e){ // touch start
    
      if(e.touches.length>=2){
        
        this.startZoom(e);
        return;
      }

      this.animate=false
      this.start.x=e.targetTouches[0].clientX;
      this.start.y=e.targetTouches[0].clientY;
      eventBus.$emit("CAROUSSEL_IMG_ROTATION",{type:"start",position:this.position});
    },
    tm(e){ // touch move
      
      // zooming
      if(this.zooming){
        
        this.moveZoom(e);
        
        return;
      }

      // dont do swiping if stillin zoom
      if(this.zoomScale>1.0){
          return;
      }




      this.checkScrollLock(e);
      
      var end={
          x:e.targetTouches[0].clientX,
          y:e.targetTouches[0].clientY
      }
     
      this.delta.x=end.x-this.start.x;
      this.delta.y=end.y-this.start.y;
      if(Math.abs(this.delta.x)>4 && !this.lockScroll.x){
        eventBus.$emit("CAROUSSEL_IMG_ROTATION",{type:"move",position:this.position});
        this.lockScroll={x:false,y:true}
        this.p.x=this.delta.x;
      }
      if(Math.abs(this.delta.y)>4 && !this.lockScroll.y){
        this.lockScroll={x:true,y:false}
      }
      
    },
    te(e){ // touch end
      if(e.touches.length>0){
        return;
      }
      // zooming
      if(this.zooming){
        this.endZoom();
        return;
      }

      if(this.zooming){
        return;
      }
      // end for swiping

      if(!this.lockScroll.x)
      {
        if(this.delta.x<-(25)){
          if(this.position<this.medias.length-1){
            this.position++;
            
            eventBus.$emit("STOP_ALL_VIDEOS");
          
          }
          
        }
        if(this.delta.x>(25)){
          if(this.position>0){
            this.position--;
            
            eventBus.$emit("STOP_ALL_VIDEOS");
          }
        }

        
        this.animate=true;
       
        eventBus.$emit("CAROUSSEL_IMG_ROTATION",{type:"end",position:this.position});
        eventBus.$emit("LAZY_LOAD_POSITION",{position:this.position});
      }

      // swipe up exit fullscreen
      if(!this.lockScroll.y && this.fullScreen && Math.abs(this.delta.y)>(25)){
        this.toggleFullScreen();
      }
      


      this.delta.x=0;
      this.p.x=0;
      this.delta.y=0;

      this.lockScroll.x=false;
      this.lockScroll.y=false;

    },
    startZoom(e){
      var px1=e.touches[0].clientX;
        var py1=e.touches[0].clientY;

        var px2=e.touches[1].clientX;
        var py2=e.touches[1].clientY;

        var p={x:px2-px1,y:py2-py1}
        this.zoomStart=Math.sqrt(Math.pow(p.y, 2) + Math.pow(p.x, 2));
        // pinch zoom!
        this.zooming=true;
    },
    moveZoom(e){
      
      var px1=e.touches[0].clientX;
        var py1=e.touches[0].clientY;

        var px2=e.touches[1].clientX;
        var py2=e.touches[1].clientY;

        var p={x:px2-px1,y:py2-py1}

        this.zoomAdd=(Math.sqrt(Math.pow(p.y, 2) + Math.pow(p.x, 2)) -this.zoomStart )/100;
        this.zoomScale=this.zoomBase+this.zoomAdd;

        
        if(this.zoomScale<1.0){
          this.zoomScale=1.0;
        }

        if(this.zoomScale>2.0){
          this.zoomScale=2.0;
        }

        eventBus.$emit("CAROUSSEL_IMG_ZOOM",{type:"zoom", position:this.position, scale:this.zoomScale});

        
    },
    endZoom(){
      this.zoomBase=this.zoomScale;
      this.zoomAdd=0;
      this.zooming=false;
    },
    checkScrollLock(e){
      if(this.lockScroll.y && e.cancelable){
        // prevent page scrolling
        e.preventDefault();
        
      }
    },
    clickedSmallGalleryThumbnail(index){
     
      this.zoomScale=1.0;
      this.position=index;
      this.animate=true;
      eventBus.$emit("CAROUSSEL_IMG_ROTATION",{type:"end",position:this.position});
      eventBus.$emit("LAZY_LOAD_POSITION",{position:this.position});
    },
    animateToFullScreen(){
      var target=this.imageViewport;
      
      this.fullScreen=true;

      this.$store.dispatch("caroussel_fullscreen",this.fullScreen)

      anime({
          targets: target,
          opacity: 0,
          scale:.9,
          backgroundColor:'rgba(0,0,0,0)',
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          document.body.appendChild(target);
          target.classList.toggle("full-screen");
          
          anime({
            targets: target,
            opacity: 1,
            scale:1,
            backgroundColor:'rgba(0,0,0,.75)',
            duration:250,
            easing: 'easeInSine',
          })
          
        });
    },
    animateFromFullScreen(){
      var target=this.imageViewport;
      this.fullScreen=false;

      this.$store.dispatch("caroussel_fullscreen",this.fullScreen)

      anime({
          targets: target,
          opacity: 0,
          scale:.9,
          backgroundColor:'rgba(0,0,0,0)',
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          this.placeHolder.appendChild(target);
          target.classList.toggle("full-screen");
          anime({
            targets: target,
            opacity: 1,
            scale:1,
            backgroundColor:'rgba(0,0,0,0)',
            duration:250,
            easing: 'easeInSine',
          })
         
        });
    },
    toggleFullScreen(){
      this.fullScreen=!this.fullScreen;
      
      if(this.fullScreen){
        this.animateToFullScreen();
      }else{
        this.animateFromFullScreen();
      }
    },
    addListeners(){
      if(!this.imageViewport){return;}
      this.imageViewport.addEventListener('touchstart',this.ts);
      this.imageViewport.addEventListener('touchend',this.te);
      this.imageViewport.addEventListener('touchmove',this.tm,{passive:false});
      // android backbutton support
      document.addEventListener("backbutton", this.backButtonAndroid, false);
     
    },
    removeListeners(){
      if(!this.imageViewport){return;}
      this.imageViewport.removeEventListener('touchstart',this.ts);
      this.imageViewport.removeEventListener('touchend',this.te);
      this.imageViewport.removeEventListener('touchmove',this.tm);
      // android backbutton support
      document.removeEventListener("backbutton", this.backButtonAndroid, false);
    },
    backButtonAndroid(){
      // end fullscreen
      this.animateFromFullScreen();
    }
  },
  beforeDestroy(){
    this.removeListeners();
  },
  updated(){

      this.empty=this.medias ? !this.medias.length : true;
  },
  mounted(){

    this.placeHolder=this.$refs['caroussel-placeholder'];
    this.element=this.$refs['caroussel-container'];
    this.imageViewport=this.$refs['image-viewport'];
    this.addListeners();
    
   
    
    
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hide{
  opacity:.2;
}
.no-media{
 position:absolute;
 top:0;
 left:0;
 width:100%;
 height:100%;
 display:flex;
 justify-content: center;
 align-items: center;
}

.caroussel-container{
  position:relative;
  width:100%;
  height:60%;
  min-height:60%;
  overflow:hidden;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  background-color:#EEEEEE;
}

.placeholder{
  flex:1;
}

.image-viewport{
  position:relative;
  width:100%;
  height:100%;
}

.caroussel-images{
  white-space: nowrap;
  overflow:visible;
  width:100%;
  height:100%;
}
.animate{
   transition:transform .25s;
}
.full-screen{
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  z-index:100;
}

.tools-left{
  position:absolute;
  left:5px;
  bottom:5px;
  z-index:10;
}

.tools-right{
  position:absolute;
  bottom:5px;
  right:5px;
  z-index:10;
}

.icon-tool{
  font-size:1.5em;
  margin-left:10px;
  margin-right:10px;
}

.dl-button{
  opacity:0;
  transition: opacity .25s;

}
.show-dl-button{
  opacity:1
}
.counting-container{
  width:100%;
 position:absolute;
 text-align:center;
  bottom:15px;
}
.counting{
 
  font-size:.7em;

}


</style>
